import { useState } from 'react';

import { ArrowLeft2, Gps } from 'iconsax-react';

import { InputSearchAddress } from '@/domain/address/components/InputSearch';
import { MapAddress } from '@/domain/address/components/Map';
import { AddressStep } from '@/domain/address/models/addressStep';
import { Tooltip } from '@/shared/components/Tooltip';
import { useAddressContext } from '@/shared/contexts/AddressContext';
import { useAuthContext } from '@/shared/contexts/AuthContext';
import { executeEvent } from '@/shared/events/Firebase/firebaseEvents';
import { Button, Container } from '@develop-fapp/ui-kit-fapp';

import { Wrapper } from './styles';

export const SearchAddress = () => {
  const { isLoggedin } = useAuthContext();
  const {
    userAddresses,
    geoLocation,
    inputSearchAddress,
    mapRef,
    setCurrentStep,
    setGeoLocation,
    setInputSearchAddress,
    setMapRef,
    setSelectAddressToEdit,
    onUseMyLocation,
    clearState,
  } = useAddressContext();

  const [previousStep] = useState<AddressStep>(
    !userAddresses.length ? 'empty' : 'create',
  );

  const onClickAddressConfirmation = () => {
    setCurrentStep('edit');
  };

  const handleClickUseLocation = () => {
    executeEvent('click_newAddress_useLocation', {});
    onUseMyLocation();
  };

  const handleOnGoBack = () => {
    setCurrentStep(previousStep);
    clearState();
  };

  return (
    <Wrapper>
      <header>
        {isLoggedin && (
          <ArrowLeft2 onClick={handleOnGoBack} size={24} variant="Outline" />
        )}
        <InputSearchAddress
          inputSearchValue={inputSearchAddress}
          placeholder="Digite seu endereço"
          setSelectAddressToEdit={setSelectAddressToEdit}
          setGeoLocation={setGeoLocation}
          setInputSearchValue={setInputSearchAddress}
        />
        <Tooltip
          active
          content="Use sua localização atual."
          direction="bottom-left"
          horizontalAlign={0.7}
          verticalAlign={2.25}
        >
          <Container justifyContent="center" alignItems="center">
            <Gps onClick={handleClickUseLocation} size={24} variant="Outline" />
          </Container>
        </Tooltip>
      </header>

      <main>
        {(geoLocation.latitude !== null || geoLocation.longitude !== null) && (
          <MapAddress
            geoLocation={geoLocation}
            mapRef={mapRef}
            setGeoLocation={setGeoLocation}
            setMapRef={setMapRef}
          />
        )}
      </main>

      <footer>
        <Button
          type="button"
          id="btn-confirm-address"
          variant="contained"
          color="primary"
          onClick={onClickAddressConfirmation}
          disabled={!geoLocation.latitude && !geoLocation.longitude}
        >
          Confirmar endereço
        </Button>
      </footer>
    </Wrapper>
  );
};
